<template>
   <div class="change-item-c">
      <div class="change-item-base-wrapper" :class="isDetailsVisible ? 'visible' : ''" @click="isDetailsVisible = !isDetailsVisible">
         <section class="change-item-wrapper">
            <section class="change-item-inner-wrapper">
               <div class="change-item-c-meta-item">
                  <span class="change-item txt-bolder txt-large">{{ task.id }}</span>
                  <span class="change-item">{{ task.status }} </span>

                  <span class="change-item-badge" :class="'gts-badge ETaskSubStatus-' + task.subStatus"> {{ task.subStatus | ETaskSubStatus }} </span>
               </div>
            </section>
         </section>
         <section class="change-item-wrapper">
            <section class="change-item-inner-wrapper highlighted">
               <!-- Flight -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">{{ $t("changeHistoryTable_thRoute") }}</span>
                  <span class="change-item txt-bold">{{ task.flight.route }}</span>
               </div>
               <!-- Cabin Type -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">{{ $t("changeHistoryTable_thCabinType") }}</span>
                  <span class="change-item txt-bold">{{ task.flight.cabinType }}</span>
               </div>
               <!-- Marketing / Operating  -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">{{ $t("changeHistoryTable_thMarketingOperating") }}</span>
                  <span class="change-item txt-bold">{{ task.flight.marketingOperating }}</span>
               </div>
            </section>
            <section class="change-item-inner-wrapper">
               <!-- Flight -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">ID</span>
                  <span class="change-item txt-bold">{{ task.flight.identifier }}</span>
               </div>
               <!-- Cabin Type -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">{{ $t("changeHistoryTable_lblType") }}</span>
                  <span class="change-item txt-bold">{{ task.flight.type | ETaskType }}</span>
               </div>
               <!-- Marketing / Operating  -->
               <div class="change-item-c-meta-item">
                  <span class="change-item">{{ $t("changeHistoryTable_lblTaskOpeningTime") }}</span>
                  <span class="change-item txt-bold">{{ task.flight.openingTime }}</span>
               </div>
            </section>
         </section>
         <section class="change-item-wrapper">
            <section class="change-item-inner-wrapper">
               <button class="change-item-c-toggle-button">
                  <i class="gts-icon icon-arrow-down icon-xs"></i>
               </button>
            </section>
         </section>
      </div>
      <div class="change-item-details-wrapper" v-if="isDetailsVisible">
         <ChangeItemDetails :task="task" />
      </div>
   </div>
</template>

<script>
import ChangeItemDetails from "./ChangeItemDetails.vue";
export default {
   components: {
      ChangeItemDetails,
   },
   props: {
      task: {
         type: Object,
         required: true,
      },
   },
   data() {
      return {
         isDetailsVisible: this.task.subStatus != 6,
      };
   },
   methods: {
      toggleDetails() {
         this.detailsVisible = !this.detailsVisible;
      },
   },
};
</script>

<style lang="scss" scoped>
.change-item-badge {
   transform: scale(0.9);
   transform-origin: left center;
}
.change-item-c {
   border: 2.5px solid #e5e7eb;
   border-radius: 0.5rem;
   // padding: 1rem 1.5rem;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: space-between;
   overflow: hidden;
   margin: 0.75rem 0;

   .change-item-base-wrapper {
      padding: 1rem;
      width: 100%;
      display: flex;
      justify-content: space-between;
      @media (max-width: 1400px) {
         flex-wrap: wrap;
      }
      &:hover {
         background-color: #eee;
         cursor: pointer;
      }

      &.visible {
         background-color: #eee; // White background
         .highlighted {
            background-color: #fff;
            border-radius: 0.5rem;
            border: none !important;
         }

         .change-item-c-toggle-button {
            transform: rotate(180deg);
            i {
               filter: brightness(100);
            }
         }

         section.change-item-wrapper {
            &:first-child {
               border-right: none !important;
            }
         }
      }

      section.change-item-wrapper {
         // border: 1px solid;
         display: flex;
         width: 100%;
         padding: 0 1rem;
         @media (max-width: 1400px) {
            flex-wrap: wrap;
         }

         &:first-child {
            border-right: 1px solid;
            width: fit-content;
            padding-left: 0;
            min-width: 240px;

            @media (max-width: 1400px) {
               border-right: none;
            }

            section.change-item-inner-wrapper {
               justify-content: flex-start;
            }
         }
         &:last-child {
            width: fit-content;
            padding-right: 0;
         }

         section.change-item-inner-wrapper {
            display: flex;
            width: 100%;
            gap: 2rem;
            padding: 1rem;
            justify-content: space-evenly;
            @media (max-width: 1400px) {
               justify-content: space-between;
            }

            &.highlighted {
               border-right: 1px solid;
            }
            .change-item-c-meta-item {
               display: flex;
               flex-direction: column;

               span {
                  white-space: nowrap;
               }
            }
            .change-item-c-toggle-button {
               display: flex;
               justify-content: center;
               align-items: center;
               width: 40px;
               height: 40px;
               background-color: var(--primary);
               border-radius: 50%;
               cursor: pointer;

               &:hover {
                  background-color: var(--accent-primary);
               }
               i {
                  filter: brightness(100);
               }
            }
         }
      }
   }
   .change-item-details-wrapper {
      width: 100%;
      padding: 1rem;
   }
}
</style>
